// https://gnosisscan.io/address/0x8Dc5310fc9D3D7D1Bb3D1F686899c8F082316c9F
export const CROSS_CHAIN_CONTROLLER = '0x8Dc5310fc9D3D7D1Bb3D1F686899c8F082316c9F';

// https://gnosisscan.io/address/0xF937ffAeA1363e4Fa260760bDFA2aA8Fc911F84D
export const CL_EMERGENCY_ORACLE = '0xF937ffAeA1363e4Fa260760bDFA2aA8Fc911F84D';

// IPayloadsControllerCore https://gnosisscan.io/address/0x9A1F491B86D09fC1484b5fab10041B189B60756b
export const PAYLOADS_CONTROLLER = '0x9A1F491B86D09fC1484b5fab10041B189B60756b';

// https://gnosisscan.io/address/0xF1c11BE0b4466728DDb7991A0Ac5265646ec9672
export const PC_DATA_HELPER = '0xF1c11BE0b4466728DDb7991A0Ac5265646ec9672';

// https://gnosisscan.io/address/0x4A9F571E3C1f2F13567bb59e38988e74d7d72602
export const GRANULAR_GUARDIAN = '0x4A9F571E3C1f2F13567bb59e38988e74d7d72602';

// https://gnosisscan.io/address/0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b
export const GOVERNANCE_GUARDIAN = '0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b';

// https://gnosisscan.io/address/0x1dF462e2712496373A347f8ad10802a5E95f053D
export const EXECUTOR_LVL_1 = '0x1dF462e2712496373A347f8ad10802a5E95f053D';

export const CHAIN_ID = 100;
